import { render, staticRenderFns } from "./ansi-puncture.vue?vue&type=template&id=76287b95&"
import script from "./ansi-puncture.vue?vue&type=script&lang=js&"
export * from "./ansi-puncture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports